import { FormDate } from "@/app/components/FormDate";
import { Entity } from "@/app/fields/types";
import { useSyncedParamValue } from "@/app/hooks/useSyncedParams";
import {
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
  Text,
} from "@chakra-ui/react";
import { Form, FormLayout } from "@saas-ui/react";

export function DateFieldFilter<T extends Entity>({
  label,
  field,
  isDisabled,
}: {
  field: string;
  label: string;
  isDisabled: boolean;
}) {
  const [localStart, setLocalStart] = useSyncedParamValue(`${field}__start`);
  const [localEnd, setLocalEnd] = useSyncedParamValue(`${field}__end`);
  return (
    <>
      <AccordionButton>
        <Box as="span" flex="1" textAlign="left">
          {label}
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>
        <Form onSubmit={() => {}}>
          <FormLayout>
            <div className="grid grid-cols-3 gap-2">
              <label className="m-0 flex items-center">
                <Text size="lg">Start</Text>
              </label>
              <div className="col-span-2" data-cy="form-control-start-date">
                <FormDate
                  isDisabled={isDisabled}
                  value={localStart || undefined}
                  onChange={(value) => setLocalStart(value || null)}
                />
              </div>
              <label className="m-0 flex items-center">
                <Text size="lg">End</Text>
              </label>
              <div className="col-span-2" data-cy="form-control-end-date">
                <FormDate
                  isDisabled={isDisabled}
                  value={localEnd || undefined}
                  onChange={(value) => setLocalEnd(value || null)}
                />
              </div>
            </div>
          </FormLayout>
        </Form>
      </AccordionPanel>
    </>
  );
}
